import JLHome from "./containers/JLHome";
import LicenceHome from "./containers/LicenceHome";
import ClubsHomePage from "./pages/ClubsHomePage";
import EvidenceLibraryPageWithState from "./pages/EvidenceLibraryPage";
import FilePreviewPage from "./common/FilePreviewPage";
import PerformancePlan from "./pages/PerformancePlan";
import GoalsAndStrategy from "./pages/GoalsAndStrategy";
import EvaluationDashboardPage from "./pages/EvaluationDashboardPage";
import LicenseAnalyticsPage from "./pages/licenseAnalytics/licenseAnalyticsPage/licenseHomePage";
import SettingsPage from "./containers/SettingsPage";

export const routes:any = {
  '/home': {
    component: JLHome,
    clubRequired: false,
  },
  '/evaluation/criteria': {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/standards": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/standards/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/standards/:id/evaluationreports": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/standards/:id/actions/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/actions": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/actions/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/evaluation/criteria/:id/evidences": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions/:id/criteria": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions/:id/criteria/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions/:id/criteria/:id/standards": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/onsite/sessions/:id/criteria/:id/standards/:id": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/reports": {
    component: ClubsHomePage,
    clubRequired: true,
  },
  "/licence/criteria": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/standards": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/standards/:id": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/standards/:id/actions/:id": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/actions": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/actions/:id": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/licence/criteria/:id/evidences": {
    component: LicenceHome,
    clubRequired: true,
  },
  "/performanceplan/projects": {
    component: PerformancePlan,
    clubRequired: true,
  },
  "/performanceplan/projects/:id": {
    component: PerformancePlan,
    clubRequired: true,
  },
  "/performanceplan/projects/:id/actions/:id": {
    component: PerformancePlan,
    clubRequired: true,
  },
  "/performanceplan/actions": {
    component: PerformancePlan,
    clubRequired: true,
  },
  "/performanceplan/actions/:id": {
    component: PerformancePlan,
    clubRequired: true,
  },
  "/goals": {
    component: GoalsAndStrategy,
    clubRequired: true,
  },
  "/goals/:id": {
    component: GoalsAndStrategy,
    clubRequired: true,
  },
  "/goals/:id/project/:id": {
    component: GoalsAndStrategy,
    clubRequired: true,
  },
  "/goals/:id/subgoal/:id": {
    component: GoalsAndStrategy,
    clubRequired: true,
  },
  "/evidencelibrary": {
    component: EvidenceLibraryPageWithState,
    clubRequired: false,
  },
  "/preview": {
    component: FilePreviewPage,
    clubRequired: true,
  },  
  "/dashboard/evaluation": {
    component: EvaluationDashboardPage,
    clubRequired: false,
  },
  "/dashboard/licence": {
    component: EvaluationDashboardPage,
    clubRequired: false,
  },
  "/dashboard/people": {
    component: EvaluationDashboardPage,
    clubRequired: false,
  },
  "/dashboard/dates": {
    component: EvaluationDashboardPage,
    clubRequired: false,
  },
  "/dashboard/progress": {
    component: EvaluationDashboardPage,
    clubRequired: false,
  },
  "/licenceanalytics/finance/dashboard": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/finance/explore": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/staff/dashboard": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/staff/explore": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/facilities/dashboard": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/facilities/explore": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/teams/dashboard": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/teams/explore": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/players/dashboard": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/licenceanalytics/players/explore": {
    component: LicenseAnalyticsPage,
    clubRequired: false,
  },
  "/settings": {
    component: SettingsPage,
    clubRequired: false,
  },
}